/*
 * Quick view drawer + a pre-existing theme-bug guard.
 *
 * 1) Shared-modal deferred-wipe race (the "just the overlay" strand):
 *    #ThemeModal is a single shared element. theme's hideModal defers
 *    `#ThemeModal.innerHTML = ''` (+ is-quick-view strip) to a transitionend /
 *    1s timeout. Close one quick-view then open another and the stale cleanup
 *    empties the freshly-opened modal — theme-modal-open stays on the body, so
 *    only the overlay is left. We neutralise the destructive cleanup at the
 *    element level: block an empty-wipe while a modal is open, and re-assert
 *    is-quick-view if a stale strip removes it. Survives theme updates.
 *
 * 2) Desktop drawer presentation:
 *    Drive the slide the way the cart drawer does — toggle qv-drawer /
 *    qv-drawer-open with a forced reflow between them (qv-no-transition primes
 *    the off-screen start) so a plain transition (custom.css) animates
 *    deterministically. Desktop only; mobile keeps its native bottom sheet. Also
 *    re-enables touch-drag on the mobile media slider.
 */
(function () {
  var DESKTOP = 768;

  // --- 1) Guard the shared modal against the stale deferred wipe ---
  function guardModal() {
    var m = document.getElementById('ThemeModal');
    if (!m || m.__qvGuarded) return !!m;
    var desc = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
    if (!desc || !desc.set) return true;
    m.__qvGuarded = true;

    // A stale close firing over a fresh open tries to empty the modal — ignore it.
    Object.defineProperty(m, 'innerHTML', {
      configurable: true,
      get: function () { return desc.get.call(this); },
      set: function (value) {
        if (value === '' && document.body.classList.contains('theme-modal-open')) return;
        return desc.set.call(this, value);
      }
    });

    // Re-add is-quick-view if a stale cleanup strips it while a quick-view is open.
    new MutationObserver(function () {
      if (document.body.classList.contains('theme-modal-open') &&
          m.querySelector('[data-quick-view-product]') &&
          !m.classList.contains('is-quick-view')) {
        m.classList.add('is-quick-view');
      }
    }).observe(m, { attributes: true, attributeFilter: ['class'] });

    return true;
  }
  if (!guardModal()) document.addEventListener('DOMContentLoaded', guardModal);

  // --- 2) Desktop drawer ---
  function modal() {
    return document.querySelector('#ThemeModal');
  }
  function isQuickView(m) {
    return m && m.classList.contains('is-quick-view');
  }
  function enableSlider(m) {
    var slider = m.querySelector('#productMediaMobile .swiper');
    if (slider && slider.swiper) {
      slider.swiper.allowTouchMove = true;
      slider.swiper.params.allowTouchMove = true;
      slider.swiper.update();
    }
  }
  function onOpen() {
    var m = modal();
    if (!isQuickView(m) || window.innerWidth < DESKTOP) return;
    m.classList.add('qv-drawer', 'qv-no-transition');
    void m.offsetWidth; // reflow: paint the off-screen start before opening
    m.classList.remove('qv-no-transition');
    m.classList.add('qv-drawer-open');
    var tries = 0;
    (function attempt() {
      enableSlider(m);
      if (tries++ < 12) setTimeout(attempt, 100);
    })();
  }
  function onClose() {
    var m = modal();
    if (!m) return;
    m.classList.remove('qv-drawer-open'); // slide out via the transition
    setTimeout(function () {
      if (!document.body.classList.contains('theme-modal-open')) {
        m.classList.remove('qv-drawer', 'qv-no-transition');
      }
    }, 550);
  }

  new MutationObserver(function () {
    if (document.body.classList.contains('theme-modal-open')) {
      onOpen();
    } else {
      onClose();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
